import MapOverlayView from './MapOverlayView';
import InfoWindowView from './InfoWindowView';

import _ from 'underscore';


export default class MarkerView extends MapOverlayView {
  get infoWindowView() {
    return InfoWindowView;
  }

  get openDetailOptions() {
    return {
      model: this.model,
      map: this.map,
      marker: this.gOverlay
    };
  }

  get overlay() {
    return google.maps.Marker;
  }

  get overlayOptions() {
    return Object.assign(super.overlayOptions, {
      position: this.model.getLatLng(),
      title: this.model.title,
      visible: false
    });
  }

  initialize(options) {
    if (!this.model) {
      throw new Error("A model must be specified for a MarkerView");
    }
    super.initialize(options);
  }

  // Show the google maps marker overlay
  render() {
    super.render();
    this.gOverlay.setVisible(true);
    return this;
  }

  remove() {
    this.closeDetail();
    super.remove(arguments);
    return this;
  }

  openDetail() {
    if (!this.infoWindowView) {
      throw new Error("An InfoWindow must be specified for opening");
    }
    if (!this.detailView) {
      this.detailView = new this.infoWindowView(this.openDetailOptions);
    }
    this.detailView.render();
  }

  closeDetail() {
    if (this.detailView) {
      this.detailView.remove();
      delete this.detailView;
    }
  }
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/backbone/views/geo/MarkerView.js
 **/